import { DateTime } from 'luxon'
import { Employee, employeeFromDto, EmployeeID, EmployeeJson } from '../../employees/models/employee'
import { Skill, skillFromDto, SkillID, SkillJson } from '../../skills/models/skill'

declare const EmployeeSkillIDSymbol: unique symbol
export type EmployeeSkillID = string & { [EmployeeSkillIDSymbol]: never }

type SkillRelationDto = {
    data: SkillJson
} | null

type EmployeeRelationDto = {
    data: EmployeeJson
} | null

export interface EmployeeSkillDto {
    id: string

    valid_from?: string | null
    valid_to?: string | null

    employee_id: string
    employee?: EmployeeRelationDto

    skill_id: string
    skill?: SkillRelationDto
}

export interface EmployeeSkill {
    id: EmployeeSkillID

    validFrom: DateTime | null
    validTo: DateTime | null

    employeeId: EmployeeID
    employee?: Employee

    skillId: SkillID
    skill?: Skill
}

export const createEmployeeSkill = (
    params: {
        id: EmployeeSkillID

        validFrom: DateTime | null
        validTo: DateTime | null

        employeeId: EmployeeID
        employee?: Employee

        skillId: SkillID
        skill?: Skill
    }
): EmployeeSkill => ({
    id: params.id,

    validFrom: params.validFrom,
    validTo: params.validTo,

    employeeId: params.employeeId,
    employee: params.employee,

    skillId: params.skillId,
    skill: params.skill,
})

export const employeeSkillFromDto = (dto: EmployeeSkillDto): EmployeeSkill => (createEmployeeSkill({
    id: dto.id as EmployeeSkillID,

    validFrom: dto.valid_from ? DateTime.fromISO(dto.valid_from) : null,
    validTo: dto.valid_to ? DateTime.fromISO(dto.valid_to) : null,

    employeeId: dto.employee_id as EmployeeID,
    employee: dto.employee ? employeeFromDto(dto.employee.data) : undefined,

    skillId: dto.skill_id as SkillID,
    skill: dto.skill ? skillFromDto(dto.skill.data) : undefined,
}))